import { useEffect, useState } from 'react';
import { getTierCeiling } from '../PlansPageUtils';
export const useTeamSizeAndBillingFrequency = _ref => {
  let {
    data
  } = _ref;
  const [teamSize, setTeamSize] = useState(0);
  const [billingFrequency, setBillingFrequency] = useState('monthlyPricingPlan');
  const [lastTierCeiling, setLastTierCeiling] = useState(0);
  useEffect(() => {
    if (data !== null && data !== void 0 && data.editions && data.editions.length > 0) {
      var _data$editions$, _data$editions$$prici;
      const pricingItem = (_data$editions$ = data.editions[0]) === null || _data$editions$ === void 0 ? void 0 : (_data$editions$$prici = _data$editions$.pricingPlan[billingFrequency]) === null || _data$editions$$prici === void 0 ? void 0 : _data$editions$$prici.tieredPricing;
      if (pricingItem && pricingItem.length > 0) {
        const firstTierCeiling = getTierCeiling(pricingItem[0]);
        setTeamSize(firstTierCeiling);
        setLastTierCeiling(getTierCeiling(pricingItem[pricingItem.length - 1]));
      }
    }
  }, [data === null || data === void 0 ? void 0 : data.editions]);
  const onTeamSizeChange = count => {
    setTeamSize(count);
  };
  const onBillingFrequencyChange = event => setBillingFrequency(event.target.value);
  return {
    teamSize,
    billingFrequency,
    onTeamSizeChange,
    onBillingFrequencyChange,
    lastTierCeiling
  };
};